export const bringPortalToFront = (onAfterOpen) => (params) => {
  const portal = params?.overlayEl?.parentNode;
  const focused = document.activeElement;
  portal?.parentNode?.appendChild(portal);
  if (focused && portal?.contains(focused)) focused.focus();
  onAfterOpen?.(params);
};
